export class CartApi {
  public static baseUrl = '/cart';
}
